import { render, staticRenderFns } from "./_ModuleEntityTemplate.vue?vue&type=template&id=53befc10&scoped=true&"
import script from "./_ModuleEntityTemplate.vue?vue&type=script&lang=js&"
export * from "./_ModuleEntityTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53befc10",
  null
  
)

export default component.exports